import feathersClient from "../../feathers-client";

const defaultBlockReasonPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultBlockReasonPaginationFilter = {
	$skip:defaultBlockReasonPagination.$skip,
	$limit: defaultBlockReasonPagination.$limit
};

export default {
	state:{
		BlockReason:[],
		BlockReasonPagination:defaultBlockReasonPagination,
		BlockReasonPaginationFilter:defaultBlockReasonPaginationFilter
	},
	getters:{
		setBlockReasonPage:(state) => {
			const {$limit, $skip} = state.BlockReasonPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_BLOCK_REASON:(state,data) => {state.BlockReason = data;},
		SET_BLOCK_REASON_PAGINATION:(state, data) => {state.BlockReasonPagination = {...state.BlockReasonPagination, ...data};},
		SET_BLOCK_REASON_PAGINATION_FILTER:(state,data) => {state.BlockReasonPaginationFilter  = {...state.BlockReasonPaginationFilter, ...data};}

	},
	actions:{
		setBlockReasonListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.BlockReasonPagination.$limit;
			commit('SET_BLOCK_REASON_PAGINATION', { $skip });
			commit('SET_BLOCK_REASON_PAGINATION_FILTER', { $skip });
		},

		getBlockReason: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/blocked-users-reasons').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_BLOCK_REASON',results.data);
			commit('SET_BLOCK_REASON_PAGINATION', {total :results.total})
			return results.data;
		},
		createBlockReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/blocked-users-reasons').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateBlockReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/blocked-users-reasons').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteBlockReason: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/blocked-users-reasons').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getBlockReasonById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/blocked-users-reasons').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getAllBlockReasonForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/blocked-users-reasons').find({
				query:{
					$role:rootGetters.currentUserRole,

				}
			});
			return results;
		},
		getAllBlocksReason: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/blocked-users-reasons').find({
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		}

	}
}
